import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useMemo } from "react";
import { useOutletContext } from "react-router";
import Loader from "components/Common/loader";
import CustomButton from "components/Common/ui/CustomButton";
import useStudentExit from "feature-module/academic/student-exit/hooks/useStudentExit";
import StudentExitTable from "feature-module/academic/student-exit/components/StudentExitTable";
import AddEditStudentExit from "feature-module/academic/student-exit/components/AddEditStudentExit";
import TableFilterDynamique from "components/Common/TableFilter/TableFilterDynamique";
import { FilterField } from "components/Common/TableFilter/TableFilter";

type Ctx = { student: any | null };

const StudentExitTab: React.FC = () => {
  const { t } = useTranslation();
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const { student } = useOutletContext<Ctx>();
  const studentId = useMemo(() => student?.id, [student]);

  const {
    fetchStudentExits,
    studentExits,
    loading,
    infoPagination,
    // handleCreate,
    // handleUpdate,
    // handleReject,
    handleComplete,
    handleDelete,
    // handleGetGuardianByStudentId,
    // handleGetAuthorizedByStudentId,
    // selectedStudentExit,
    // setSelectedStudentExit,
    statusOptions,
    exitTypeOptions,
  } = useStudentExit();

  const [filters, setFilters] = useState<{ [key: string]: string | number | null }>({});

  // const handleSave = async (payload: any) => {
  //   try {
  //     let result = false;
  //     const finalPayload = {
  //       ...payload,
  //       studentId: studentId,
  //     };

  //     if (selectedStudentExit?.id) {
  //       result = await handleUpdate(selectedStudentExit.id, finalPayload);
  //     } else {
  //       result = await handleCreate(finalPayload);
  //     }

  //     if (result) {
  //       setSelectedStudentExit(null);
  //       refetchData();
  //     }
  //     return result;
  //   } catch (error) {
  //     console.error("Error saving student exit:", error);
  //     return false;
  //   }
  // };

  const handleFilter = (newFilters: { [key: string]: any }) => {
    setFilters(newFilters);
    refetchData(newFilters);
  };

  const refetchData = (currentFilters = filters) => {
    const params = {
      ...currentFilters,
      studentId: studentId,
      page: 1,
      limit: 10,
    };

    fetchStudentExits(params);
  };

  // const handleAddNew = () => {
  //   setSelectedStudentExit(null);
  //   setIsModalOpen(true);
  // };

  // const handleCloseModal = () => {
  //   setSelectedStudentExit(null);
  //   setIsModalOpen(false);
  // };

  // const handleEdit = (record: any) => {
  //   setSelectedStudentExit(record);
  //   setIsModalOpen(true);
  // };



  // const handleRejectExit = async (id: string) => {
  //   const result = await handleReject(id);
  //   if (result) {
  //     refetchData();
  //   }
  // };

  const handleCompleteExit = async (id: string) => {
    const result = await handleComplete(id);
    if (result) {
      refetchData();
    }
  };

  const handleDeleteExit = async (id: string) => {
    const result = await handleDelete(id);
    if (result) {
      refetchData();
    }
  };

  useEffect(() => {
    if (studentId) {
      refetchData();
    }
  }, [studentId]);

  const filterFields: FilterField[] = useMemo(
    () => [
      { key: "search", label: t("search"), type: "text" },
      { key: "status", label: t("studentExit.form.status"), type: "select", options: statusOptions },
      { key: "exitType", label: t("studentExit.form.exitType"), type: "select", options: exitTypeOptions },
      { key: "exitTime", label: t("studentExit.form.exitTime"), type: "range", rangeKeys: { start: "startDate", end: "endDate" } },
    ],
    [t, statusOptions, exitTypeOptions]
  );

  if (loading) return <Loader />;

  return (
    <div className="p-2">

      <>
        <div className="d-flex mb-3 justify-content-end gap-2">
          <TableFilterDynamique
            fields={filterFields}
            filters={filters}
            onApply={handleFilter}
            onReset={() => handleFilter({ page: 1, limit: 10 })}
          />
          {/* <CustomButton
            onClick={handleAddNew}
          >
            <i className="ti ti-plus me-2" />
            {t("studentExit.add")}
          </CustomButton> */}
        </div>

        <StudentExitTable
          dataSource={studentExits}
          loading={loading}
          // onEdit={handleEdit}
          // onReject={handleRejectExit}
          onComplete={handleCompleteExit}
          onDelete={handleDeleteExit}
          dataPaginate={{
            current: infoPagination?.page,
            pageSize: infoPagination?.limit,
            total: infoPagination?.total,
          }}
          onChange={(pg: any) => {
            const params = {
              ...filters,
              studentId: studentId,
              page: pg.current!,
              limit: pg.pageSize!,
            };
            fetchStudentExits(params);
          }}
        />

        {/* <AddEditStudentExit
          isOpen={isModalOpen}
          selectedStudentExit={selectedStudentExit}
          onClose={handleCloseModal}
          onSave={handleSave}
          students={[student]} // Only show the current student in the tab context
          onGetGuardianByStudentId={handleGetGuardianByStudentId}
          onGetAuthorizedByStudentId={handleGetAuthorizedByStudentId}
        /> */}
      </>

    </div>
  );
};

export default StudentExitTab;